const units = [
	["B", 1],
	["KB", 1000],
	["MB", 1000_000],
	["GB", 1000_000_000],
	["TB", 1000_000_000_000],
] as const;

function roundToNSignificantDigits(num: number, n: number) {
	const factor = Math.floor(Math.log10(num) - n + 1);
	const rounded = Math.round(num / 10 ** factor) * 10 ** factor;
	return rounded;
}

/**
 * Humanizes a number of bytes into a string with an SI prefix.
 *
 * Chooses the largest unit that is less than or equal to the number
 * of bytes, i.e. it won't ever start with 0 unless bytes is less than 1.
 *
 * @param bytes - The number of bytes to humanize.
 * @returns A string, e.g. "1.344 MB"
 */
export default function humanizeBytes(bytes: number) {
	for (let i = units.length - 1; i >= 0; i--) {
		const [unit, factor] = units[i];
		if (bytes >= factor) {
			return `${roundToNSignificantDigits(bytes / factor, 3)} ${unit}`;
		}
	}

	return `${bytes} B`;
}
